// extracted by mini-css-extract-plugin
export default {"p__card":"ExistingPaymentType_p__card__ritNz","p__rVieBtn":"ExistingPaymentType_p__rVieBtn__SmU0c","p__detail":"ExistingPaymentType_p__detail__JjKrh"};